import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import IconButton from '@material-ui/core/IconButton'
import MenuItem from '@material-ui/core/MenuItem'
import TextField from '@material-ui/core/TextField'
import EditIcon from '@material-ui/icons/Edit'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { selectEasymsRatesKV } from '../../../../../selectors/expediaSelectors/expediaEasymsSelector'

class RateEditDialog extends React.Component {
    static propTypes = {
        item: PropTypes.object.isRequired,
        open: PropTypes.bool.isRequired,
        easymsRatesKV: PropTypes.array.isRequired,
        onUpdate: PropTypes.func.isRequired,
        onClose: PropTypes.func.isRequired,
        onOpen: PropTypes.func.isRequired
    }

    state = {
        ourId: this.props.item.ourId || ''
    }

    handleClickOpen = () => {
        const { onOpen, item } = this.props
        onOpen(item.remoteId)
    }

    handleClose = () => {
        this.props.onClose()
    }

    handleSelect = prop => event => {
        this.setState({ [prop]: event.target.value })
    }

    handleSave = () => {
        const { item, onUpdate } = this.props
        const { ourId } = this.state

        onUpdate({ ...item, ourId })
        this.handleClose()
    }

    render() {
        const { open, item, easymsRatesKV } = this.props
        return (
            <div>
                <IconButton aria-label="Edit" onClick={this.handleClickOpen}>
                    <EditIcon />
                </IconButton>

                <Dialog open={open} onClose={this.handleClose} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Редактирование тарифа (Remote ID: {item.remoteId})</DialogTitle>
                    <DialogContent>
                        <TextField
                            fullWidth
                            select
                            label="Тариф EasyMS"
                            value={this.state.ourId}
                            onChange={this.handleSelect('ourId')}
                        >
                            {easymsRatesKV.map(option => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            Отмена
                        </Button>
                        <Button onClick={this.handleSave} color="primary">
                            Сохранить
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

export default connect(state => ({
    easymsRatesKV: selectEasymsRatesKV(state)
}))(RateEditDialog)



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/ExpediaTab/MappingTabs/RatesTab/RateEditDialog.js